import { animate, style, transition, trigger } from '@angular/animations';

export const animSlideFromTop = trigger('animSlideFromTop', [
    transition(':enter', [
        style({ 'transform-origin': 'top', height: '0px', opacity: '0' }),
        animate('.15s', style({ height: '*', opacity: '1' }))
    ]),
    transition(':leave', [
        style({ 'transform-origin': 'top', height: '*', opacity: '1' }),
        animate('.15s', style({ height: '0px', opacity: '0' }))
    ])
]);

export const animSlideFromBottom = trigger('animSlideFromBottom', [
    transition(':enter', [
        style({ 'transform-origin': 'bottom', height: '0px', opacity: '0' }),
        animate('.15s', style({ height: '*', opacity: '1' }))
    ]),
    transition(':leave', [
        style({ 'transform-origin': 'bottom', height: '*', opacity: '1' }),
        animate('.15s', style({ height: '0px', opacity: '0' }))
    ])
]);
